import React, { Component } from 'react';
// import Moment from 'react-moment';
import moment from 'moment';
import Countdown from 'react-countdown-now';
import cx from 'classnames';
// moment(Date.parse(time)).format()


const Renderer = ({ minutes, seconds, completed, id, onClick, isActualTaking }) => {
  if ( completed ) {
    return (
      <button
        className="rooms-btn"
        id={id}
        onClick={onClick}
      >
        Zaklep
      </button>
    )
  } else {
    if (isActualTaking) {
      return (
        <button
          className="rooms-btn rooms-btn--actual"
          id={id}
          onClick={onClick}
        >
          Wróć {minutes}:{seconds}
        </button>
      )
    }

    return (
      <span className="rooms-isblocked">Zablokowane {minutes}:{seconds}</span>
    )
  }
}

export default class SingleRoom extends Component {
  render() {
    const { roomName, size, freeSize, id, time, onTakeRoom, isActualTaking } = this.props;
    const classes = cx({
      'isFull': freeSize == 0
    })
    // const date = isActualTaking ? 0 : moment(Date.parse(time)).format();

    return (
      <tr className={classes}> 
        <td>Pokój {roomName}</td>
        <td>{size}</td>
        <td>{freeSize}</td>
        <td className="rooms-table-last">
          <Countdown
            date={time === 0 ? 0 : moment(Date.parse(time)).format()}
            renderer={Renderer}
            id={id}
            isActualTaking={isActualTaking}
            onClick={onTakeRoom}
          />
        </td>
      </tr>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/User/components/SingleRoom.js